<template>
	<el-dialog title="重新分配达人" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
		<div class="title">现跟进人：</div>
		<el-table :data="talentPartnerList" header-row-class-name="table-header-row" row-class-name="table-row">
			<el-table-column prop="partner_role_name" label="跟进人"></el-table-column>
			<el-table-column prop="cooperate_status" label="合作状态" width="100"></el-table-column>
			<el-table-column prop="cooperate_time" label="最近跟进时间" width="170"></el-table-column>
			<el-table-column label="待跟进事项">
				<template v-slot="{ row: { wait_data = {} } }">
					<div>待寄样数 {{ wait_data.wait_send_num }}</div>
					<div>待收货数 {{ wait_data.wait_receive_num }}</div>
					<div>待排期数 {{ wait_data.wait_plan_num }}</div>
					<div>待开播数 {{ wait_data.wait_live_num }}</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="title mt-12" style="color: #86909d">请选择要分配的员工，分配后由员工继续跟进合作</div>
		<div class="mb-16 flex">
			<el-input class="mr-16" v-model="partner_role_name" clearable placeholder="请输入员工名称" />
			<el-button type="primary" @click="getPartnerList">搜索</el-button>
		</div>
		<el-table :data="list" header-row-class-name="table-header-row" row-class-name="table-row">
			<el-table-column min-width="40">
				<template v-slot="{ row }">
					<el-radio v-model="to_user_id" :label="row.user_id">{{ '' }}</el-radio>
				</template>
			</el-table-column>
			<el-table-column label="员工名称" min-width="170">
				<template v-slot="{ row }">
					<div class="flex flex-align-center">
						<yx-avatar size="small" :src="row.avatar_url"></yx-avatar>
						<p class="ml-6">{{ row['partner_name'] }}</p>
						<el-tag v-if="row.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
						<el-tag class="ml-8" v-else-if="row.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="mobile" label="手机号" min-width="150"></el-table-column>
			<el-table-column prop="anchor_count" label="当前跟进达人数" min-width="140"></el-table-column>
		</el-table>
		<yx-pagination
			:total="total"
			:current-page="pageInfo.page_index"
			:page-size="pageInfo.page_size"
			@size-change="sizeChange"
			@current-change="currentChange"
		/>
		<span slot="footer">
			<el-button type="primary" :loading="loading" @click="submit">确认分配</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { getPartnerList, teamSeaAllot, getTalentPartnerList } from '@/api/talentCRM';
import { drRoleType } from '@/utils/dataMap';
export default {
	name: 'anewAllocationDialog',
	data() {
		return {
			dialogVisible: false,
			anchor_id: 0,
			to_user_id: 0,
			partner_role_name: '',
			list: [],
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			talentPartnerList: [],
			loading: false,
		};
	},
	methods: {
		show(anchor_id) {
			this.anchor_id = anchor_id;
			this.getPartnerList();
			this.getTalentPartnerList();
			this.dialogVisible = true;
		},
		handleClose() {
			this.anchor_id = this.to_user_id = 0;
			this.partner_role_name = '';
			this.dialogVisible = false;
		},
		async getTalentPartnerList() {
			const { anchor_id } = this;
			const { code, data = [] } = await getTalentPartnerList({ anchor_id });
			if (code !== 0) return;
			this.talentPartnerList = data;
		},
		async getPartnerList() {
			const { partner_role_name } = this;
			const { code, data: { list = [], page = {} } = {} } = await getPartnerList({
				partnerName: partner_role_name,
				...this.pageInfo,
			});
			if (code !== 0) return;
			this.list = list;
			this.total = page.item_total;
			this.to_user_id = 0;
		},
		sizeChange(size) {
			this.pageInfo.page_size = size;
			this.getPartnerList();
		},
		currentChange(index) {
			this.pageInfo.page_index = index;
			this.getPartnerList();
		},
		async submit() {
			const { anchor_id, to_user_id, talentPartnerList = [] } = this;
			if (!to_user_id) return this.$message.error('请选择要分配的员工');
			this.loading = true;
			try {
				const from_user_ids = talentPartnerList.map(item => item.user_id).join();
				const { code } = await teamSeaAllot({ anchor_id, from_user_ids, to_user_id });
				if (code !== 0) return;
				this.$message.success('重新分配成功');
				this.$emit('getList');
				this.handleClose();
			} finally {
				this.loading = false;
			}
		},
	},
	components: {},
};
</script>

<style lang="less" scoped>
.title {
	font-size: 14px;
	color: #1d1f23;
	margin-bottom: 12px;
}
/deep/ .el-radio {
	margin-left: 6px;
}
/deep/ .el-radio .el-radio__label {
	display: inherit;
}
.follow {
	padding: 12px 16px;
	background: rgba(0, 83, 219, 0.03);
}
/deep/ .el-table__body-wrapper {
	max-height: 300px;
	overflow-y: auto;
}
/deep/ .el-dialog__body {
	padding-bottom: 0px !important;
}
/deep/ .el-dialog__footer {
	padding-top: 0px;
}
</style>
